import { render } from "./MatchList.vue?vue&type=template&id=11090f73&scoped=true"
import script from "./MatchList.vue?vue&type=script&lang=js"
export * from "./MatchList.vue?vue&type=script&lang=js"

import "./MatchList.vue?vue&type=style&index=0&id=11090f73&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11090f73"]])

export default __exports__